// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2KM2i","inputDescription":"styles_inputDescription__3BOkY"};